export const blockIconsUiactionsCancelNew = (
	<span className='material-symbols-outlined'>cancel</span>
);
